<template>
  <div class="viphub_main">
    <div class="receive_cou" v-if="show_cou">
      <div class="receive_cou_con" @click="show_cou = false"></div>
      <img
        :src="receive_cou_bg"
        class="receive_cou_img"
        @click="receiveCoupon"
      />
    </div>
    <div class="viphub_banner">
      <img src="../../assets/images/img2/viphub_banner.png" />
    </div>
    <div class="con">
      <div class="index_mod1top">
        <div class="index_mod1text">
          <p class="index_mo1tit1">开通配音会员</p>
          <p class="index_mo1tit2">畅享无限免费试听导出</p>
        </div>
        <div class="index_mod1bg"></div>
      </div>
      <div class="vip_hub_open">
        <div class="vip_hub_openli" @click="showOpenvip({val:true,tab:0})">
          <img src="../../assets/images/img2/open_vip.png" alt="" />
          <div class="vip_hub_opentext">
            <p>升级VIP尊享5大权益</p>
            <p>普通主播随心用，无限导出</p>
          </div>
        </div>
        <div class="vip_hub_openli" @click="showOpenvip({val:true,tab:1})">
          <img src="../../assets/images/img2/open_svip.png" alt="" />
          <div class="vip_hub_opentext">
            <p>升级VIP尊享15大权益</p>
            <p>金牌主播、常用工具任您用</p>
          </div>
        </div>
      </div>
    </div>
    <div class="viphub_con">
      <div class="con">
        <div class="index_mod1top">
          <div class="index_mod1text">
            <p class="index_mo1tit1">会员特权对比</p>
            <p class="index_mo1tit2">激活会员尊贵高人一等</p>
          </div>
          <div class="index_mod1bg"></div>
        </div>
        <div class="vipqy">
          <img src="../../assets/images/img2/openvip_unVIP.png" alt="" />
          <img src="../../assets/images/img2/openvip_VIP.png" alt="" />
          <img src="../../assets/images/img2/openvip_SVIP.png" alt="" />
        </div>
        <div class="vip_prompt">
          <p class="vip_prompt_tit">温馨提示</p>
          <p>
            1.VIP特权仅限于智能配音的导出和分享，<span>暂不支持真人配音</span>，真人配音一单一价，若有其他疑问，请咨询客服。
          </p>
          <p>
            2.若开通特权后10分钟内标识仍然没有点亮，请退出账号后重新登录进行尝试，或联系客服。
          </p>
          <p>
            3.开通特权则默认您已同意配音神器<span>《用户协议》</span>、<span>《隐私协议》</span>及<span>《特权服务协议》</span>。
          </p>
          <p>4.特权时长中，1个月=30天。</p>
          <p>如有其他疑问，请前往<span>帮助与反馈>></span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      receive_cou_bg: "", //优惠卷图片
      show_cou: false, //优惠卷显示状态
      coupon: {}, //获取到的优惠卷信息
    };
  },
  mounted() {
    this.queryCoupon();
  },
  methods: {
      ...mapMutations(["showOpenvip"]),
    // 查询优惠卷
    queryCoupon() {
      let self = this;
      let url =
        self.$store.state.base_api + self.$store.state.base_url.qrycoupon;
      let json = {
        ctime: self.$store.state.userinfo.ctime,
        isvip: self.$store.state.userrich.viptype
          ? self.$store.state.userrich.viptype
          : "0",
      };
      this.$request.postHttp(json, url, (decData) => {
        self.coupon = decData.model[0];
        self.receive_cou_bg = decData.model[0].bgimg;
      });
    },
    // 领取优惠卷
    receiveCoupon() {
      let self = this;
      let url =
        self.$store.state.base_api + self.$store.state.base_url.getusercoupon;
      let json = {
        yhqid: this.coupon.yhqid,
        opertype: "1",
      };
      this.$request.postHttp(json, url, (decData) => {
        if (decData.rc == "0") {
          self.show_cou = false;
        }
        console.log(decData);
      });
    }
  },
};
</script>

<style>
@import url("../../assets/css/viphub.css");
</style>




// WEBPACK FOOTER //
// src/view/recharge/viphub.vue